import { action, makeObservable } from 'mobx';

import { MenuItem } from '../../../app/data/model';
import { MenuItemState } from '../../../app/layout/MenuItemState';
import { MenuItemActivator } from '../../../app/layout/NavigationState';
import { SearchInputState } from '../../../app/layout/SearchInputState';
import StoreSelectionState from '../../../app/layout/StoreSelectionState';
import { SiteHeaderTranslation } from '../../../app/localization/SiteTranslation';
import ExternalLinks from '../../../app/shared/externalLinks';
import { INavigationService } from '../../../app/shared/NavigationService';
import StoreAndLanguageSelectorState from './StoreAndLanguageSelector/StoreAndLanguageSelectorState';

export default class SiteHeaderState {
  public menuItems: MenuItemState[] = [];
  public readonly searchInputState: SearchInputState;
  public readonly storeAndLanguageSelectorState: StoreAndLanguageSelectorState;

  public get isSearchEnabled() {
    return !!this.searchUrl;
  }

  public constructor(
    public readonly homeUrl: string = ExternalLinks('flokk'),
    public readonly searchUrl: string,
    menuItems: MenuItem[],
    private readonly navigationService: INavigationService,
    storeSelectionState: StoreSelectionState,
    public readonly translation: SiteHeaderTranslation,
  ) {
    makeObservable(this);

    this.initializeMenuItems(menuItems);
    this.searchInputState = new SearchInputState(navigationService);
    this.searchInputState.initialize(this.searchUrl);
    this.storeAndLanguageSelectorState = new StoreAndLanguageSelectorState(
      storeSelectionState,
      this.translation.storeAndLanguageSelector,
    );
  }

  private initializeMenuItems(menuItems: MenuItem[]) {
    this.setMenuItems(menuItems);
    this.markActiveItems();
    this.navigationService.pageLoaded.subscribe(() => this.markActiveItems());
  }

  @action.bound
  private markActiveItems() {
    const currentUrlPath = this.navigationService.currentUrl.toString(true);
    MenuItemActivator.markActiveItems(currentUrlPath, this.menuItems);
  }

  private setMenuItems(menuItems: MenuItem[]) {
    if (menuItems) {
      menuItems.forEach((item, index) => {
        if (item.name) {
          this.menuItems.push(new MenuItemState(item, 0, index));
        }
      });
    }
  }
}
